import { render, staticRenderFns } from "./SidebarLinks.vue?vue&type=template&id=748c6821&scoped=true&"
import script from "./SidebarLinks.vue?vue&type=script&setup=true&lang=js&"
export * from "./SidebarLinks.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SidebarLinks.vue?vue&type=style&index=0&id=748c6821&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c6821",
  null
  
)

export default component.exports